// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/neosans/NeoSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/neosans/NeoSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/neosans/NeoSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/neosans/NeoSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/neosans/NeoSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/neosans/NeoSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fontello-cf67082d/font/dataflock.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fontello-cf67082d/font/dataflock.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fontello-cf67082d/font/dataflock.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/images/desktop_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/images/close_collapse.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/images/open_collapse.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --white: #ffffff;
  --gray-33: #333333;
  --primary-74: #7479ff;
  --purple: #9b51e0;
  --green: #228b22;
}

@font-face {
  font-family: "NeoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "NeoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: "dataflock";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

html {
  font-family: "NeoSans", Inter, ui-sans-serif, system-ui, -apple-system,
    "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

html,
body {
  height: 100%;
  margin: 0;
  overflow-x: hidden; /* no horizontal scroll */
  overscroll-behavior: none; /* prevent “bounce” overscroll */
}

body {
  padding: 0;
  box-sizing: border-box;
  margin: 0;
  font-family: inherit;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.main_content_wrap {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  display: flex;
  padding: 2px;
  position: relative;
}

.sidebar_wrap {
  width: 80px;
  padding: 10px;
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none;
  box-shadow: 0px 0px 3px 0px #f2f2f2 inset, 0px 0px 3px 0px #ffffff80 inset,
    -1px -1px 0.5px -1px #ffffff inset, 1px 1px 0.5px -1px #ffffff inset,
    -1px -1px 0px -0.5px #262626 inset, 1px 1px 0px -0.5px #333333 inset;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 2;
  transition: all 0.15s ease-in;
}

.sidebar_wrap.pin_sidebar {
  width: 300px;
}

.brand_text {
  font-family: dataflock;
}

.brand_wordmark {
  display: flex;
  align-items: center;
  gap: 6px;
}

.brand_letter {
  display: block;
  height: 24px;
  width: auto;
}

.pin_sidebar .user_section .user_detail,
.pin_sidebar .sidebar__menu__list .nav_list_text,
.pin_sidebar .brand_text,
.pin_sidebar .user_info {
  width: 100% !important;
  visibility: visible !important;
  opacity: 1 !important;
  padding-left: 0;
}
.sidebar_wrap .user_section .user_detail,
.sidebar_wrap .sidebar__menu__list .nav_list_text,
.sidebar_wrap .brand_text,
.sidebar_wrap .user_info {
  width: 0;
  visibility: hidden;
  opacity: 0;
  transition: width 0.3s ease-in, opacity 0.25s ease-in;
}

.sidebar__menu__list .nav_list_text,
.brand_text,
.user_info {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Keep Signality letter SVGs on a single horizontal row. */
.brand_text.brand_wordmark {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}

.sidebar_wrap .brand_section,
.sidebar_wrap .user_section {
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}

.brand_logo-icon {
  width: 40px;
  height: auto;
  transition: opacity 0.25s ease;
}

.brand_logo-full {
  display: none;
  max-width: 180px;
}

.brand_logo-full svg {
  width: 100%;
  height: auto;
  display: block;
}

.pin_sidebar .brand_logo-full,
.sidebar_wrap:hover .brand_logo-full {
  display: block;
}

.pin_sidebar .brand_logo-icon,
.sidebar_wrap:hover .brand_logo-icon {
  display: none;
}

.sidebar_wrap:hover {
  width: 300px;
  .user_section .user_detail,
  .sidebar__menu__list .nav_list_text,
  .brand_text,
  .user_info {
    width: 100%;
    visibility: visible;
    opacity: 1;
    padding-left: 0;
  }
}

/* .main_layout_content {
  margin-left: 80px;
  flex: 1;
  padding: 20px;
  transition: all 0.3s ease-in-out;
} */

.main_layout_content {
  transition: all 0.3s ease-in-out;
  flex: 1 1;
  padding: 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Content shift when sidebar pinned */
/* sidebar is position:fixed so margin alone doesn't reduce flex item width — max-width corrects that */
.main_layout_content.content_unpinned {
  margin-left: 80px;
  max-width: calc(100% - 80px);
}

.main_layout_content.content_pinned {
  margin-left: 300px;
  max-width: calc(100% - 300px);
}

.layout_body {
  flex: 1 1;
}

.sidebar__menu {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar__menu-sections {
  flex: 1 1;
}

.sidebar__menu-top,
.sidebar__menu-center,
.sidebar__menu-bottom {
  display: flex;
  flex-direction: column;
}

.sidebar__menu-center {
  justify-content: center;
  flex: 1 1;
  max-height: 50px;
}

.user_section {
  max-height: 70px;
  margin-bottom: 20px;
}

.sidebar__menu-bottom {
  margin-top: auto;
}

.sidebar__menu__list {
  list-style: none;
}
.sidebar__menu__list li {
  padding: 0px 19px;
  border-radius: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0;
  transition: all 0.2s ease;
}
.sidebar__menu__list li a {
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  padding: 13px 0px;
  transition: all 0.2s ease;
}

.pin_sidebar .sidebar__menu__list li a,
.sidebar_wrap:hover .sidebar__menu__list li a {
  gap: 12px;
}

.sidebar__menu__list li a:hover {
  color: var(--primary-74);
}
.sidebar__menu__list li:hover {
  background: #eff6ff1a;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3);
}
.active_list {
  background: #eff6ff1a;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
}
.active_list a {
  color: var(--primary-74) !important;
}
.active_list .sidebar_icon {
  filter: brightness(0) saturate(100%) invert(42%) sepia(70%) saturate(1165%)
    hue-rotate(220deg) brightness(100%) contrast(100%);
}

.sidebar__menu__list li:hover .sidebar_icon {
  filter: brightness(0) saturate(100%) invert(42%) sepia(70%) saturate(1165%)
    hue-rotate(220deg) brightness(100%) contrast(100%);
}
.sidebar__menu__list .badge {
  margin-left: auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--purple);
  display: flex;
  align-items: center;
  justify-content: center;
}
.user_section .user_avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
.sidebar_list_box {
  height: 74dvh;
}

/* header */
.header-container {
  padding-top: 20px;
}
.header_left_side {
  width: 50%;
}
/* Shared styles */
/* Default collapsed state */
/* Lupe / KI-Stern in den Suchfeldern: echter Submit-Button ohne Browser-Stil */
.search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.search-bar,
.ai_bar {
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(116, 121, 255, 0.2);
  height: 42px;
  border-radius: 42px;
  padding: 9px;
  transition: all 0.3s ease-in-out;
  width: 42px;
  overflow: hidden;
  cursor: text;
  flex-shrink: 0;
}

.ai_bar::before,
.search-bar::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px;
  border-radius: inherit;
  background: linear-gradient(45deg, #4635d2, #322699, #7479ff);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
}

/* Expand when active */
.search-bar:hover,
.search-bar:focus-within {
  width: 75%;
}

.ai_bar:hover,
.ai_bar:focus-within {
  width: 75%;
}

/* Input expand effect */
.search-txt {
  border: none;
  background: none;
  outline: none;
  color: #fff;
  line-height: 1.9rem;
  width: 0;
  padding: 0;
  transition: width 0.4s ease, padding 0.4s ease;
  flex: 1 1;
  min-width: 0;
  z-index: 1;
  font-size: 14px;
  &::placeholder {
    color: #ffffffbf;
  }
}

.search-bar:hover .search-txt,
.search-bar:focus-within .search-txt {
  width: 100%;
  padding: 0 10px;
}

.ai_bar:hover .search-txt,
.ai_bar:focus-within .search-txt {
  width: 100%;
  padding: 0 10px;
}

.search-bar:hover ~ .ai_bar,
.search-bar:focus-within ~ .ai_bar {
  width: 42px !important;
}

.search-bar:hover ~ .ai_bar .search-txt,
.search-bar:focus-within ~ .ai_bar .search-txt {
  width: 0 !important;
  padding: 0 !important;
}

/* If .ai_bar is active → keep .search-bar collapsed */
.ai_bar:hover ~ .search-bar,
.ai_bar:focus-within ~ .search-bar {
  width: 42px !important;
}

.ai_bar:hover ~ .search-bar .search-txt,
.ai_bar:focus-within ~ .search-bar .search-txt {
  width: 0 !important;
  padding: 0 !important;
}

.ai-assistant-btn {
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(3px);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
}
.circle_gridient_btn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 2px;
    border-radius: inherit;
    background: linear-gradient(45deg, #4635d2, #322699, #7479ff);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
  }
}

/* generate report bar */
.generate_report_wrap {
  .generate_report_field {
    position: relative;
    background: rgba(116, 121, 255, 0.2);
    border-radius: 35px;
    flex: 1 1;
    padding: 3px 20px 3px 60px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    width: 100%;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      padding: 2px;
      border-radius: inherit;
      background: linear-gradient(45deg, #4635d2, #322699, #7479ff);
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask-composite: exclude;
      pointer-events: none;
    }

    .search-txt {
      width: 100%;
      background: transparent;
      border: none;
      outline: none;
      color: #fff;
      height: 42px;
      max-height: 200px;
      overflow: auto;
      resize: none;
      font-size: 14px;
      display: block;
      padding: 10px 0;
      padding-top: 13px !important;
      line-height: 1.4;
      &::placeholder {
        color: #ffffffbf;
      }
      &::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    .magic_icon {
      position: absolute;
      top: 11px;
      left: 20px;
    }
  }
}

/* news card */

.main__content__box {
  padding: 50px 0px 0px;
  min-height: 50rem;
}

.news_list_box {
  height: 100rem;
  overflow-y: scroll;
  scrollbar-width: none;
  padding: 2px;
}

.latest_news_card .latest_news_image_box {
  width: 100%;
  aspect-ratio: 16/9;
}

.latest_news_card .mini_title {
  top: 20px;
  right: 20px;
  color: rgba(255, 255, 255, 0.6);
}

.latest_news_card_overlay {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 15px;
  border: 1px solid rgba(51, 51, 51, 0.2);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 30px;
  margin-top: -8%;
}
.news-card {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  /* height: 288px; */
}

.reportCard {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 15px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  height: 245px;
}
.reportCard .news_image_box {
  height: 245px;
}
.reportCard_description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-card .row {
  height: 100%;
}
.news-card .row > [class*="col-"] {
  height: 100%;
}
.card_detail_box {
  padding: 14px;
}
.news_card_title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
}
.card_description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0;
}
.news_image_box {
  height: 288px;
}
.news_detail {
  .active_news {
    width: 6px;
    height: 6px;
    background: var(--green);
    border-radius: 50px;
    display: inline-block;
    margin-right: 10px;
  }
  .category {
    background: rgba(51, 51, 51, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding: 3px 10px;
    font-size: 12px;
    max-width: 140px;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    word-break: break-word;
    overflow-wrap: anywhere;
    line-height: 1.25;
  }
  .post_time {
    color: var(--white);
    display: inline-block;
    flex-shrink: 0;
    font-size: 12px;
  }
}

.progress-container {
  width: 100%;
  max-width: 32px;
  aspect-ratio: 1;
}

.circular-progress {
  --size: 100%;
  --thickness: 2px;
  --angle: calc(var(--progress) * 3.6deg);
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  background: conic-gradient(#22c55e var(--angle), #2e2e3d 0deg 360deg);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 6px;
}

.circular-progress::before {
  content: "";
  position: absolute;
  width: calc(100% - var(--thickness) * 2);
  height: calc(100% - var(--thickness) * 2);
  background-color: #1e1e2f;
  border-radius: 50%;
}

.progress-value {
  position: relative;
  color: white;
  font-size: 10px;
}

/* all news tabs */
.news_comments {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  padding: 16px;
}
.news_comments--fixed {
  height: auto;
  display: block;
  box-sizing: border-box;
}
.news_comments--fixed .news-tab-content {
  overflow: visible;
}
.comment_title {
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.comment_description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.news_socialMedia_block,
.news_sourace_block {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 6px 14px;
  border-radius: 6px;
      box-shadow: rgba(116, 121, 255, 0.2) 0px 0px 4px inset;
}
.news_sourace_block .source-avatars .source-icon {
  margin-left: -12px;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  background-color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  object-fit: contain;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  &:first-child {
    margin-left: 0;
  }
}
.source-avatars .source_avtar_link{
  margin-left: -6px;
  display:inline-block;
  &:first-child {
    margin-left: 0;
  }
}
.global-impact-popover {
  position: absolute;
  width: min(260px, calc(100% - 24px));
  max-height: min(220px, calc(100% - 24px));
  overflow: hidden;
  padding: 12px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: radial-gradient(circle at 70% 20%, rgba(84, 84, 100, 0.3), rgba(22, 24, 34, 0.96));
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  z-index: 30;
}
.global-impact-popover.is-pinned {
  border-color: rgba(132, 204, 255, 0.4);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(132, 204, 255, 0.25) inset;
}
.global-impact-popover-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.global-impact-popover-title {
  color: #fff;
  font-size: 15px;
  line-height: 1.2;
  font-weight: 700;
}
.global-impact-popover-count {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
}
.global-impact-popover-subtitle {
  color: rgba(255, 255, 255, 0.82);
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 8px;
}
.global-impact-popover-sources {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 150px;
  overflow-y: auto;
}
.global-impact-source-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 24px;
  color: #fff;
  text-decoration: none;
}
.global-impact-source-link:hover {
  color: #fff;
  text-decoration: underline;
}
.global-impact-source-icon {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: #fff;
  object-fit: contain;
  flex-shrink: 0;
}
.global-impact-source-name {
  color: #fff;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 500;
}
.global-impact-source-empty {
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
}
.source-more-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  z-index: 5;
}
.source-more-trigger {
  cursor: pointer;
}
.source-more-popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 260px;
  max-width: 340px;
  max-height: 320px;
  overflow-y: auto;
  background: rgba(20, 20, 28, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);
  padding: 10px;
  z-index: 2000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(4px);
  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;
}
.news-detail-panel {
  position: relative;
  z-index: 20;
}
.customize-article-panel {
  position: relative;
  z-index: 1;
}
.source-more-wrapper:hover .source-more-popover,
.source-more-wrapper:focus-within .source-more-popover {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.source-more-title {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
}
.source-more-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.source-more-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 12px;
  padding: 6px 8px;
  border-radius: 8px;
}
.source-more-link {
  text-decoration: none;
}
.source-more-link:hover {
  background: rgba(255, 255, 255, 0.08);
}
.source-more-icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  object-fit: cover;
  flex: 0 0 auto;
}
.source-more-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.source-more-note {
  color: rgba(255, 255, 255, 0.65);
  font-style: italic;
}
.news_socialMedia_block .social-icon {
  width: 24px;
  height: 24px;
  border-radius: 50px;
   margin-left: -12px;
  &:first-child {
    margin-left: 0;
  }
}

.news-tabs {
  display: flex;
  gap: 10px;
  border-radius: 50px;
  background: rgba(51, 51, 51, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 4px;
  list-style: none;
  width: 100%;
}

.news-tab-item {
  flex: 1 1; /* each tab takes equal space */
}

.news-tab-btn {
  background: transparent;
  border: none;
  color: #fff;
  padding: 9px 4px;
  font-weight: 400;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 40px;
  color: #828282;
}

.news-tab-btn.active {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #fff;
  box-shadow: inset 0 0 8px rgba(116, 121, 255, 0.3);
}

.news_comment_card {
  background: rgba(51, 51, 51, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-radius: 12px;
  padding: 16px;
  color: #fff;
}

/* matching news  */

.view-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  background: #0b0b1a; /* dark background to match image */
  border-radius: 50px;
  padding: 6px;
  gap: 6px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: inset 0 0 8px rgba(116, 121, 255, 0.3);
}

.toggle_btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  font-size: 22px;
  border-radius: 40px;
  padding: 10px 16px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.5); /* inactive state */
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
}

.toggle_btn.toggle-active {
  background: rgba(255, 255, 255, 0.06);
  color: #ffffff;
  box-shadow: inset 0 0 8px rgba(116, 121, 255, 0.3);
}

.question_wrap {
  background: rgba(255, 255, 255, 0.05); /* glass effect */
  border-radius: 12px;
  padding: 30px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #f1f1f1;
  line-height: 1.6;
  font-size: 15px;
}

.matching_heading_box .title {
  font-family: "NeoSans";
  text-transform: uppercase;
}

.question_wrap h5 {
  color: #ffffff;
  font-weight: 600;
  margin-bottom: 10px;
}

.question_wrap a {
  color: var(--primary-74); /* bluish like your screenshot */
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s ease;
}

.question_wrap a:hover {
  color: var(--primary-74); /* purple on hover */
  text-decoration: underline;
}

.question_wrap strong {
  font-weight: 700;
  color: #fff;
}
/* news viwe*/

.news_views_banner_image .image_box {
  aspect-ratio: 16/9;
  width: 100%;
}
.action_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.3);
  color: var(--white);
}
.action_button_box {
  display: flex;
  align-items: center;
}
.action_box .title_box {
  border-right: 1px solid rgba(116, 121, 255, 0.3);
  display: inline-block;
  padding: 10px 20px 10px 5px;
}
.action_box .action_btn {
  border: 0;
  background: transparent;
  color: var(--white);
  display: flex;
  align-items: center;
  padding: 10px 20px;
  gap: 10px;
  border-left: 1px solid rgba(116, 121, 255, 0.3);
}

.mini_detail_box {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 28px 28px 28px 40px;
  border-radius: 12px;
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.3);
  position: relative;
  &::before {
    position: absolute;
    content: "";
    height: 80%;
    width: 2px;
    background: var(--white);
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
  }
}

.news_detail_description_box {
  a {
    color: var(--purple);
  }
  img {
    max-width: 100%;
  }
}

/* custom tool tip */
.tooltip_wrapper {
  position: relative;
  display: inline-block;
}

.custom_anchor {
  color: var(--white);
  background: var(--primary-74);
  cursor: pointer;
  position: relative;
  z-index: 1;
  margin-left: 5px;
}

.custom_tooltip_box {
  position: absolute;
  top: 26px;
  left: 20%;
  transform: translateX(-20%);
  background: rgba(255, 255, 255, 0.01);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  border-radius: 12px;
  padding: 12px;
  max-width: 450px;
  width: calc(100vw - 30px);
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  color: #ffffff;
  pointer-events: none;
  border: 1px solid rgba(255, 255, 255, 0.1);

  /* Prevent tooltip from overflowing left/right */
  box-sizing: border-box;
}

.tooltip_wrapper:hover .custom_tooltip_box {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.tooltip_content {
  display: flex;
  align-items: flex-start;
}

.tooltip_img {
  width: 90px;
  height: 90px;
  object-fit: cover;
  border-radius: 10px;
}

.tooltip_title {
  font-weight: 600;
  font-size: 1rem;
}

.tooltip_description {
  font-size: 0.85rem;
  line-height: 1.4;
}

.tooltip_buttons .custom_btn_success {
  background: #252630;
  color: var(--white);
  border-radius: 8px;
  padding: 9px 10px;
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  border: 0;
}

.tooltip_buttons .custom_btn_primary {
  background: #312b59;
  color: var(--white);
  border-radius: 8px;
  padding: 9px 10px;
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  border: 0;
}
.tooltip_buttons button {
  font-size: 0.75rem;
}

/* customize panel */
.custom_panel_box .bg_glassEffect {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  padding: 16px;
  border-radius: 25px;
  color: var(--white);
}

.custom-section-title {
  font-family: "NeoSans";
  text-align: center;
}
.custom-customize-box .custom-label {
  font-size: 14px;
  font-weight: 300;
  padding-bottom: 10px;
}
.custom-customize-box .custom_tab {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  padding: 8px;
  border-radius: 40px;
}
.custom-toggle {
  padding: 6px 10px;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
}
.activetab {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  padding: 6px 20px;
  border-radius: 40px;
  color: var(--purple);
}
.self_togle_wrap .custom-toggle {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  padding: 9px 10px;
  border-radius: 40px;
  font-size: 12px;
  cursor: pointer;
}
.self_togle_wrap .custom-toggle .activeTab {
  color: var(--purple);
}

/* share diaglog */

.share-dialog {
  position: absolute;
  top: -11rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  color: white;
  z-index: 999;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
}

.share-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.8rem;
  color: white;
}
.circle_icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 8px;
  font-size: 20px;
  cursor: pointer;
  transition: box-shadow 0.3s ease, transform 0.2s ease;
}

.circle_icon:hover {
  box-shadow: 0 0 12px rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}
/* Twitter */
.bgtwitter {
  background-color: #1da0f286;
  border: 1px solid #1da1f2;
  color: #1da1f2;
}

/* Facebook */
.bgfacebook {
  background-color: #3b599888;
  border: 1px solid #3b5998;
  color: #3b5998;
}

/* WhatsApp */
.bgtwhatsapp {
  background-color: #25d3663d;
  border: 1px solid #25d366;
  color: #25d366;
}

/* Reddit */
.bgreddit {
  background-color: #ff450048;
  border: 1px solid #ff4500;
  color: #ff4500;
}

/* footer */

.df-footer {
  color: var(--white);
  padding: 30px 0;
  font-size: 14px;
}

.df-footer-logo {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}

/* The links sit next to each other in the JSX without whitespace; as inline
   elements there is no break opportunity between them, and on narrow phones
   the row ran past the edge (clipped, since body has overflow-x: hidden).
   Wrapping flex keeps the desktop spacing (2 x 12px) and breaks into several
   centered rows on mobile. */
.df-footer-nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 24px;
  padding: 0 8px;
}

.df-footer-nav a {
  color: var(--white);
  text-decoration: none;
  white-space: nowrap;
}

.df-footer-nav a:hover {
  text-decoration: underline;
}

.df-footer-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin: 25px 0;
  width: 100%;
}
.df-footer-legal {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px 15px;
}
.df-footer-legal a {
  color: var(--white);
  font-size: 13px;
  text-decoration: none;
  white-space: nowrap;
}

.df-footer-legal a:hover {
  text-decoration: underline;
}

/* common style */
.fs_30 {
  font-size: 30px;
}
.pt_100 {
  padding-top: 100px;
}
/* media query */
@media (max-width: 1440px) {
  .flex-wrap {
    flex-direction: column-reverse;
  }
  .category_wrap {
    justify-content: space-between;
    width: 100%;
  }
}
@media (max-width: 1366px) {
  .hot_news_detail {
    flex-wrap: wrap;
  }
  /* .sidebar_wrap {
    width: 220px;
    padding: 16px;
  }
  .main_layout_content {
    margin-left: 220px;
  } */
}
@media (max-width: 1025px) {
  .header_left_side {
    width: 76%;
  }
  .news_comments {
    background: none;
    backdrop-filter: unset;
    -webkit-backdrop-filter: unset;
    border-radius: 0;
    box-shadow: none !important;
    padding: 0;
  }
  .news-tabs {
    background: rgba(51, 51, 51, 0.3);
    max-width: 550px;
    margin: 0 auto;
  }
  .pin_icon {
    display: none !important;
  }
  .generate_report_box {
    flex-wrap: wrap;
    flex-direction: column;
  }
  .search-txt.with-files {
    padding: 37px !important;
  }
}

@media (max-width: 600px) {
  .sidebar_wrap {
    width: 0px;
    padding: 4px;
    z-index: 22;
    transform: translateX(-10px);
    transition: all 0.3s ease-in-out;
  }
  .action_box .action_btn {
    padding: 10px !important;
  }
  .heading_box .news_view_title {
    font-size: 20px;
  }

  .action_button_box {
    justify-content: space-between;
    flex-grow: 1;
  }
  .sidebar_wrap.collapsed {
    width: 250px;
    overflow: hidden;
    transform: translateX(0px);
  }
  .sidebar_wrap.collapsed .user_section .user_detail,
  .sidebar_wrap.collapsed .sidebar__menu__list li span,
  .sidebar_wrap.collapsed .brand_text,
  .sidebar_wrap.collapsed .user_info {
    display: block;
    opacity: 1;
  }
  .sidebar_wrap.user_section .user_detail,
  .sidebar_wrap.sidebar__menu__list li span,
  .sidebar_wrap.brand_text,
  .sidebar_wrap.user_info {
    display: block;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    transition-delay: 0.2s;
  }
  .sidebar_wrap .brand_section,
  .sidebar_wrap .user_section,
  .sidebar__menu__list li a {
    justify-content: unset;
  }
  .main_layout_content {
    margin-left: 0px !important;
    width: 100%;
  }

  .news-tab-btn {
    font-size: 12px;
  }
  .news_comment_card {
    padding: 10px;
  }
  .df-footer-legal {
    justify-content: center;
  }
  .df-footer-nav {
    gap: 8px 18px;
  }
  .card_description {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 0;
  }
  .news_card_title {
    font-size: 18px;
  }
  .card_detail_box {
    padding: 14px 14px 0px 14px;
  }
  .action_box .title_box {
    display: none !important;
    border-right: unset !important;
    display: inline-block;
    padding: 0 !important;
  }
  .action_button_box .action_btn:first-child {
    border: none;
  }

  .main_layout_content {
    padding: 8px;
  }
}

.no-margin-top {
  margin-top: 0 !important;
}

/* Ensure UI controls inherit the global font */
input,
button,
select,
textarea {
  font: inherit;
}

.mini_transparent_btn {
  background: rgba(255, 255, 255, 0.09);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  border-radius: 5px;
  border: 0;
  outline: 0;
  color: #fff;
  padding: 6px 20px 4px;
}
.text_purple {
  color: var(--purple);
}

/* reports*/
.reportPoster_img_wrap {
  height: 200px;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
  position: relative;
  transition: all 0.3s ease;
  .title {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(10px); /* glass blur effect */
    -webkit-backdrop-filter: blur(10px);
    padding: 12px;
    text-align: center;
  }
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.4);
  }
  .report_overview_posterImg {
    bottom: unset !important;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }
}

/* === Tabs === */

.reports_souraces_tabs .custom_tabs {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 4px;
  padding: 4px;
  border-radius: 50px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: fit-content;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.reports_souraces_tabs .custom_tabs::-webkit-scrollbar {
  display: none;
}

.reports_souraces_tabs .custom_tabs .nav-item {
  flex: 0 0 auto;
}

/* Tabs (buttons) */
.reports_souraces_tabs .custom_tabs .nav-link {
  color: rgba(255, 255, 255, 0.4);
  font-weight: 600;
  font-size: 14px;
  border-radius: 50px;
  padding: 8px 18px;
  transition: all 0.3s ease;
  background: transparent;
  border: none;
  line-height: 1.2;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* Active tab */
.reports_souraces_tabs .custom_tabs .nav-link.active {
  background: #25233d;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #fff;
}

/* reports view page */

.small_cricle_icon {
  width: 26px;
  height: 26px;
  border-radius: 50px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reportViewBannerImgWrap .image_box {
  height: 250px;
  width: 100%;
  position: relative;
  .post_title {
    background: rgba(0, 0, 0, 0.52);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    padding: 10px 25px;
    border-radius: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
    z-index: 2;
  }
}

.report-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.62) 0%,
    rgba(0, 0, 0, 0.35) 40%,
    rgba(0, 0, 0, 0.72) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.bg_glassEffect {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(20px);
  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Box container */
.content_enhance_wrap {
  padding: 20px;
  color: #fff;
  max-width: 500px;
  margin: 0 auto;
}

/* Title */
.enhance_title {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* Textarea */
.enhance_textarea {
  width: 100%;
  height: 100px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 10px;
  border-radius: 8px;
  font-size: 13px;
  resize: none;
  outline: none;

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.enhance_textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

/* Buttons */
.enhance_btns {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
}

.btn_enhance,
.btn_rewrite {
  width: 120px;
  height: 34px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn_enhance:hover {
  background: rgba(255, 255, 255, 0.2);
}

.btn_rewrite.active {
  background: linear-gradient(#9999994d, #9999994d),
    linear-gradient(#333333c9, #333333c9), linear-gradient(#5e3afc33, #5e3afc33),
    #000000;
  background-blend-mode: darken, luminosity, normal;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
}

/* Trending topics */
.tranding_topic_list {
  max-height: 180px;
  overflow-y: auto;
  margin-top: 30px;
  padding: 0px 25px;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #241f3b;
  }

  &::-webkit-scrollbar {
    width: 6px;
    background-color: #241f3b;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #938585;
    border-radius: 40px;
  }
}

.tranding_topic_list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.tranding_topic_list li {
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  padding: 11px 0;
  text-align: end;
}
.tranding_topic_list li:last-child {
  border-bottom: none;
}

.reports_overview_tabsBox {
  .report_overview_accordion {
    --bs-accordion-color: #fff;
    --bs-accordion-bg: transparent;
    --bs-accordion-border-color: transparent;
    --bs-accordion-border-radius: 8px;
    --bs-accordion-btn-focus-box-shadow: none;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .accordion-item {
      background-color: transparent;
      border: none;
      box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
        2px 0 2px rgba(255, 255, 255, 0.3);
      border-radius: 8px;
      overflow: hidden;

      .accordion-header {
        .accordion-button {
          background-color: #2a283e;
          color: #fff;
          font-weight: 600;
          font-size: 14px;
          letter-spacing: 0.5px;
          border: none;
          box-shadow: none;
          padding: 12px 20px;
          border-radius: 0;
          transition: all 0.3s ease;

          &:focus {
            box-shadow: none;
          }

          &::after {
            background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
            transform: rotate(0deg);
          }

          &.collapsed::after {
            background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
          }
        }
      }

      .accordion-body {
        padding: 24px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
      }
    }
  }
}

/* ai generate report  */

/* Base textarea */
.search-txt.with-files {
  padding: 60px;
  transition: all 0.3s ease;
}

/* File preview inside input */
.inner-files-wrapper {
  position: absolute;
  top: 8px;
  left: 10%;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.inner-file-preview {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  position: relative;
  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.15);
  z-index: 22;

  .remove-file-btn {
    position: absolute;
    top: -6px;
    right: -6px;
    background: rgba(255, 255, 255, 0.3);
    border: none;
    color: #fff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    font-size: 10px;
    padding: 2px;
    line-height: 1;
    cursor: pointer;
  }
}

/* Upload modal */
.upload-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 25, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.upload-modal {
  background: rgba(60, 60, 90, 0.3);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 30px 50px;
  width: 420px;
  height: 230px;
  text-align: center;
  color: #fff;
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;

  .upload-content {
    position: relative;
    height: 100%;
    align-content: center;
    p {
      color: #ffffffb3;
      font-size: 15px;
    }

    .upload-icon {
      margin-right: 8px;
    }

    .file-input {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      cursor: pointer;
    }
  }
}

.affected_price_table {
  --bs-table-bg: transparent;
  --bs-table-color: #f0f0f0 !important;
}

/* Stability Bar */
.stability-bar {
  display: flex;
  align-items: center;
}

.stability-bar .bar {
  width: 18px;
  height: 5px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  transition: background 0.3s;
}

.stability-bar .bar.active {
  background-color: #986e3b;
}

.stability-bar .bar:not(:last-child) {
  margin-right: 3px;
}

.reportCard_wrapper {
  position: relative;
}

.reportCard_overlay {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(6px);
  background: rgba(0, 0, 0, 0.35);
  border-radius: 12px;
  z-index: 2;
}

.report-eta-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2050;
}

.report-eta-modal-content {
  min-width: 280px;
  max-width: 420px;
  border-radius: 12px;
  padding: 16px;
  color: #fff;
  background: rgba(21, 24, 38, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB;;8DAEwD;EACxD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;;8DAE6D;EAC7D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;;8DAEyE;EACzE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;oDACkD;AACpD;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,kBAAkB,EAAE,yBAAyB;EAC7C,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6DAA2D;EAC3D,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB;;wEAEsE;EACtE,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;AACjB;AACA;;;;EAIE,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,qDAAqD;AACvD;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ;;;;IAIE,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;;;;;GAKG;;AAEH;EACE,gCAAgC;EAChC,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC,uGAAuG;AACvG;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,MAAM;EACN,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB;sCACoC;AACtC;AACA;EACE,qBAAqB;EACrB;iDAC+C;AACjD;AACA;EACE,mCAAmC;AACrC;AACA;EACE;sDACoD;AACtD;;AAEA;EACE;sDACoD;AACtD;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA,kBAAkB;AAClB,4BAA4B;AAC5B,+EAA+E;AAC/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,6DAA6D;EAC7D,8EAA8E;EAC9E,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;;EAEE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,8CAA8C;EAC9C,SAAO;EACP,YAAY;EACZ,UAAU;EACV,eAAe;EACf;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,sBAAsB;IACtB,6DAA6D;IAC7D;+BAC2B;IAE3B,uBAAuB;IACvB,oBAAoB;EACtB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,SAAO;IACP,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;;IAEX;MACE,WAAW;MACX,kBAAkB;MAClB,QAAQ;MACR,YAAY;MACZ,sBAAsB;MACtB,6DAA6D;MAC7D;iCAC2B;MAE3B,uBAAuB;MACvB,oBAAoB;IACtB;;IAEA;MACE,WAAW;MACX,uBAAuB;MACvB,YAAY;MACZ,aAAa;MACb,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,cAAc;MACd,YAAY;MACZ,eAAe;MACf,cAAc;MACd,eAAe;MACf,4BAA4B;MAC5B,gBAAgB;MAChB;QACE,gBAAgB;MAClB;MACA;QACE,aAAa;MACf;MACA,qBAAqB;MACrB,wBAAwB;IAC1B;IACA;MACE,kBAAkB;MAClB,SAAS;MACT,UAAU;IACZ;EACF;AACF;;AAEA,cAAc;;AAEd;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,uCAAuC;EACvC,yCAAyC;EACzC,aAAa;EACb,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,UAAU;IACV,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;EACpB;EACA;IACE,iCAAiC;IACjC,2BAA2B;IAC3B,mCAAmC;IACnC,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qEAAqE;EACrE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;EAEE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;MACd,sDAAsD;AAC5D;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf;IACE,cAAc;EAChB;AACF;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB;IACE,cAAc;EAChB;AACF;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,8FAA8F;EAC9F,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,sFAAsF;AACxF;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,0BAA0B;EAC1B,2EAA2E;AAC7E;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;GAClB,kBAAkB;EACnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO,EAAE,+BAA+B;AAC1C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC;iDAC+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB,EAAE,mCAAmC;EACxD,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,+BAA+B,EAAE,mBAAmB;EACpD,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,qCAAqC,EAAE,iBAAiB;EACxD,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB,EAAE,gCAAgC;EAC1D,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB,EAAE,oBAAoB;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA,aAAa;;AAEb;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,wBAAwB;IACxB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;;EAE1C,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kDAAkD;EAClD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kDAAkD;EAClD,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;;AAElB;EACE,kBAAkB;EAClB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,6CAA6C;EAC7C,sBAAsB;AACxB;AACA,YAAY;AACZ;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;6BAI6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA,gBAAgB;AAChB;EACE;IACE,8BAA8B;EAChC;EACA;IACE,8BAA8B;IAC9B,WAAW;EACb;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;;;;;;KAMG;AACL;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,gCAAgC;EAClC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;;;;IAIE,cAAc;IACd,UAAU;EACZ;EACA;;;;IAIE,cAAc;IACd,UAAU;IACV,gCAAgC;IAChC,sBAAsB;EACxB;EACA;;;IAGE,sBAAsB;EACxB;EACA;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;;;;EAIE,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,2BAA2B,EAAE,sBAAsB;IACnD,mCAAmC;IACnC,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,2BAA2B;IAC3B,2CAA2C;EAC7C;EACA;IACE,wBAAwB;IACxB,+BAA+B;IAC/B,2BAA2B;IAC3B,mCAAmC;EACrC;AACF;;AAEA,iBAAiB;;AAEjB;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC;iDAC+C;EAC/C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;AACb;;AAEA,sBAAsB;;AAEtB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB;IACE,+BAA+B;IAC/B,2BAA2B;IAC3B,mCAAmC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,kDAAkD;EAClD,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;;EAEb;IACE,aAAa;EACf;EACA,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;;WAES;EACT,iDAAiD;EACjD,yCAAyC;EACzC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;;EAEjB;IACE,oDAAoD;IACpD,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,wCAAwC;IACxC,iCAAiC;IACjC,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;MACE,6BAA6B;MAC7B,YAAY;MACZ;0CACoC;MACpC,kBAAkB;MAClB,gBAAgB;;MAEhB;QACE;UACE,yBAAyB;UACzB,WAAW;UACX,gBAAgB;UAChB,eAAe;UACf,qBAAqB;UACrB,YAAY;UACZ,gBAAgB;UAChB,kBAAkB;UAClB,gBAAgB;UAChB,yBAAyB;;UAEzB;YACE,gBAAgB;UAClB;;UAEA;YACE,0DAA2D;YAC3D,uBAAuB;UACzB;;UAEA;YACE,0DAA0D;UAC5D;QACF;MACF;;MAEA;QACE,aAAa;QACb,8CAA8C;MAChD;IACF;EACF;AACF;;AAEA,wBAAwB;;AAExB,kBAAkB;AAClB;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mDAAmD;EACnD,WAAW;;EAEX;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,8CAA8C;EAC9C,yBAAyB;;EAEzB;IACE,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;MACV,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,YAAY;MACZ,WAAW;MACX,eAAe;IACjB;EACF;AACF;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iCAAiC;EACjC,2CAA2C;EAC3C,2CAA2C;AAC7C","sourcesContent":[":root {\n  --white: #ffffff;\n  --gray-33: #333333;\n  --primary-74: #7479ff;\n  --purple: #9b51e0;\n  --green: #228b22;\n}\n\n@font-face {\n  font-family: \"NeoSans\";\n  src: url(\"./assets/neosans/NeoSans.woff2\") format(\"woff2\"),\n    url(\"./assets/neosans/NeoSans.woff\") format(\"woff\"),\n    url(\"./assets/neosans/NeoSans.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"NeoSans\";\n  src: url(\"./assets/neosans/NeoSans-Bold.woff2\") format(\"woff2\"),\n    url(\"./assets/neosans/NeoSans-Bold.woff\") format(\"woff\"),\n    url(\"./assets/neosans/NeoSans-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"dataflock\";\n  src: url(\"./assets/fontello-cf67082d/font/dataflock.woff2\") format(\"woff2\"),\n    url(\"./assets/fontello-cf67082d/font/dataflock.woff\") format(\"woff\"),\n    url(\"./assets/fontello-cf67082d/font/dataflock.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\nhtml {\n  font-family: \"NeoSans\", Inter, ui-sans-serif, system-ui, -apple-system,\n    \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0;\n  overflow-x: hidden; /* no horizontal scroll */\n  overscroll-behavior: none; /* prevent “bounce” overscroll */\n}\n\nbody {\n  padding: 0;\n  box-sizing: border-box;\n  margin: 0;\n  font-family: inherit;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.main_content_wrap {\n  background: url(\"./assets/images/desktop_bg.png\") no-repeat;\n  background-position: center center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  display: flex;\n  padding: 2px;\n  position: relative;\n}\n\n.sidebar_wrap {\n  width: 80px;\n  padding: 10px;\n  position: fixed;\n  height: 100%;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  box-shadow: 0px 0px 3px 0px #f2f2f2 inset, 0px 0px 3px 0px #ffffff80 inset,\n    -1px -1px 0.5px -1px #ffffff inset, 1px 1px 0.5px -1px #ffffff inset,\n    -1px -1px 0px -0.5px #262626 inset, 1px 1px 0px -0.5px #333333 inset;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.04);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  z-index: 2;\n  transition: all 0.15s ease-in;\n}\n\n.sidebar_wrap.pin_sidebar {\n  width: 300px;\n}\n\n.brand_text {\n  font-family: dataflock;\n}\n\n.brand_wordmark {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.brand_letter {\n  display: block;\n  height: 24px;\n  width: auto;\n}\n\n.pin_sidebar .user_section .user_detail,\n.pin_sidebar .sidebar__menu__list .nav_list_text,\n.pin_sidebar .brand_text,\n.pin_sidebar .user_info {\n  width: 100% !important;\n  visibility: visible !important;\n  opacity: 1 !important;\n  padding-left: 0;\n}\n.sidebar_wrap .user_section .user_detail,\n.sidebar_wrap .sidebar__menu__list .nav_list_text,\n.sidebar_wrap .brand_text,\n.sidebar_wrap .user_info {\n  width: 0;\n  visibility: hidden;\n  opacity: 0;\n  transition: width 0.3s ease-in, opacity 0.25s ease-in;\n}\n\n.sidebar__menu__list .nav_list_text,\n.brand_text,\n.user_info {\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Keep Signality letter SVGs on a single horizontal row. */\n.brand_text.brand_wordmark {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n\n.sidebar_wrap .brand_section,\n.sidebar_wrap .user_section {\n  justify-content: flex-start;\n  align-items: center;\n  gap: 12px;\n}\n\n.brand_logo-icon {\n  width: 40px;\n  height: auto;\n  transition: opacity 0.25s ease;\n}\n\n.brand_logo-full {\n  display: none;\n  max-width: 180px;\n}\n\n.brand_logo-full svg {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.pin_sidebar .brand_logo-full,\n.sidebar_wrap:hover .brand_logo-full {\n  display: block;\n}\n\n.pin_sidebar .brand_logo-icon,\n.sidebar_wrap:hover .brand_logo-icon {\n  display: none;\n}\n\n.sidebar_wrap:hover {\n  width: 300px;\n  .user_section .user_detail,\n  .sidebar__menu__list .nav_list_text,\n  .brand_text,\n  .user_info {\n    width: 100%;\n    visibility: visible;\n    opacity: 1;\n    padding-left: 0;\n  }\n}\n\n/* .main_layout_content {\n  margin-left: 80px;\n  flex: 1;\n  padding: 20px;\n  transition: all 0.3s ease-in-out;\n} */\n\n.main_layout_content {\n  transition: all 0.3s ease-in-out;\n  flex: 1;\n  padding: 20px;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Content shift when sidebar pinned */\n/* sidebar is position:fixed so margin alone doesn't reduce flex item width — max-width corrects that */\n.main_layout_content.content_unpinned {\n  margin-left: 80px;\n  max-width: calc(100% - 80px);\n}\n\n.main_layout_content.content_pinned {\n  margin-left: 300px;\n  max-width: calc(100% - 300px);\n}\n\n.layout_body {\n  flex: 1;\n}\n\n.sidebar__menu {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.sidebar__menu-sections {\n  flex: 1;\n}\n\n.sidebar__menu-top,\n.sidebar__menu-center,\n.sidebar__menu-bottom {\n  display: flex;\n  flex-direction: column;\n}\n\n.sidebar__menu-center {\n  justify-content: center;\n  flex: 1;\n  max-height: 50px;\n}\n\n.user_section {\n  max-height: 70px;\n  margin-bottom: 20px;\n}\n\n.sidebar__menu-bottom {\n  margin-top: auto;\n}\n\n.sidebar__menu__list {\n  list-style: none;\n}\n.sidebar__menu__list li {\n  padding: 0px 19px;\n  border-radius: 8px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 0;\n  transition: all 0.2s ease;\n}\n.sidebar__menu__list li a {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  width: 100%;\n  color: #fff;\n  text-decoration: none;\n  font-size: 16px;\n  padding: 13px 0px;\n  transition: all 0.2s ease;\n}\n\n.pin_sidebar .sidebar__menu__list li a,\n.sidebar_wrap:hover .sidebar__menu__list li a {\n  gap: 12px;\n}\n\n.sidebar__menu__list li a:hover {\n  color: var(--primary-74);\n}\n.sidebar__menu__list li:hover {\n  background: #eff6ff1a;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3);\n}\n.active_list {\n  background: #eff6ff1a;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n}\n.active_list a {\n  color: var(--primary-74) !important;\n}\n.active_list .sidebar_icon {\n  filter: brightness(0) saturate(100%) invert(42%) sepia(70%) saturate(1165%)\n    hue-rotate(220deg) brightness(100%) contrast(100%);\n}\n\n.sidebar__menu__list li:hover .sidebar_icon {\n  filter: brightness(0) saturate(100%) invert(42%) sepia(70%) saturate(1165%)\n    hue-rotate(220deg) brightness(100%) contrast(100%);\n}\n.sidebar__menu__list .badge {\n  margin-left: auto;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--purple);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.user_section .user_avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.sidebar_list_box {\n  height: 74dvh;\n}\n\n/* header */\n.header-container {\n  padding-top: 20px;\n}\n.header_left_side {\n  width: 50%;\n}\n/* Shared styles */\n/* Default collapsed state */\n/* Lupe / KI-Stern in den Suchfeldern: echter Submit-Button ohne Browser-Stil */\n.search-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.search-bar,\n.ai_bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: rgba(116, 121, 255, 0.2);\n  height: 42px;\n  border-radius: 42px;\n  padding: 9px;\n  transition: all 0.3s ease-in-out;\n  width: 42px;\n  overflow: hidden;\n  cursor: text;\n  flex-shrink: 0;\n}\n\n.ai_bar::before,\n.search-bar::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  padding: 2px;\n  border-radius: inherit;\n  background: linear-gradient(45deg, #4635d2, #322699, #7479ff);\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  mask-composite: exclude;\n  pointer-events: none;\n}\n\n/* Expand when active */\n.search-bar:hover,\n.search-bar:focus-within {\n  width: 75%;\n}\n\n.ai_bar:hover,\n.ai_bar:focus-within {\n  width: 75%;\n}\n\n/* Input expand effect */\n.search-txt {\n  border: none;\n  background: none;\n  outline: none;\n  color: #fff;\n  line-height: 1.9rem;\n  width: 0;\n  padding: 0;\n  transition: width 0.4s ease, padding 0.4s ease;\n  flex: 1;\n  min-width: 0;\n  z-index: 1;\n  font-size: 14px;\n  &::placeholder {\n    color: #ffffffbf;\n  }\n}\n\n.search-bar:hover .search-txt,\n.search-bar:focus-within .search-txt {\n  width: 100%;\n  padding: 0 10px;\n}\n\n.ai_bar:hover .search-txt,\n.ai_bar:focus-within .search-txt {\n  width: 100%;\n  padding: 0 10px;\n}\n\n.search-bar:hover ~ .ai_bar,\n.search-bar:focus-within ~ .ai_bar {\n  width: 42px !important;\n}\n\n.search-bar:hover ~ .ai_bar .search-txt,\n.search-bar:focus-within ~ .ai_bar .search-txt {\n  width: 0 !important;\n  padding: 0 !important;\n}\n\n/* If .ai_bar is active → keep .search-bar collapsed */\n.ai_bar:hover ~ .search-bar,\n.ai_bar:focus-within ~ .search-bar {\n  width: 42px !important;\n}\n\n.ai_bar:hover ~ .search-bar .search-txt,\n.ai_bar:focus-within ~ .search-bar .search-txt {\n  width: 0 !important;\n  padding: 0 !important;\n}\n\n.ai-assistant-btn {\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(3px);\n  border: none;\n  color: white;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 20px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.circle_gridient_btn {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  position: relative;\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    padding: 2px;\n    border-radius: inherit;\n    background: linear-gradient(45deg, #4635d2, #322699, #7479ff);\n    -webkit-mask: linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    pointer-events: none;\n  }\n}\n\n/* generate report bar */\n.generate_report_wrap {\n  .generate_report_field {\n    position: relative;\n    background: rgba(116, 121, 255, 0.2);\n    border-radius: 35px;\n    flex: 1;\n    padding: 3px 20px 3px 60px;\n    flex-shrink: 0;\n    display: flex;\n    align-items: center;\n    width: 100%;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      padding: 2px;\n      border-radius: inherit;\n      background: linear-gradient(45deg, #4635d2, #322699, #7479ff);\n      -webkit-mask: linear-gradient(#fff 0 0) content-box,\n        linear-gradient(#fff 0 0);\n      -webkit-mask-composite: xor;\n      mask-composite: exclude;\n      pointer-events: none;\n    }\n\n    .search-txt {\n      width: 100%;\n      background: transparent;\n      border: none;\n      outline: none;\n      color: #fff;\n      height: 42px;\n      max-height: 200px;\n      overflow: auto;\n      resize: none;\n      font-size: 14px;\n      display: block;\n      padding: 10px 0;\n      padding-top: 13px !important;\n      line-height: 1.4;\n      &::placeholder {\n        color: #ffffffbf;\n      }\n      &::-webkit-scrollbar {\n        display: none;\n      }\n      scrollbar-width: none;\n      -ms-overflow-style: none;\n    }\n    .magic_icon {\n      position: absolute;\n      top: 11px;\n      left: 20px;\n    }\n  }\n}\n\n/* news card */\n\n.main__content__box {\n  padding: 50px 0px 0px;\n  min-height: 50rem;\n}\n\n.news_list_box {\n  height: 100rem;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  padding: 2px;\n}\n\n.latest_news_card .latest_news_image_box {\n  width: 100%;\n  aspect-ratio: 16/9;\n}\n\n.latest_news_card .mini_title {\n  top: 20px;\n  right: 20px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.latest_news_card_overlay {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 15px;\n  border: 1px solid rgba(51, 51, 51, 0.2);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 30px;\n  margin-top: -8%;\n}\n.news-card {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 15px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  /* height: 288px; */\n}\n\n.reportCard {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 15px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  height: 245px;\n}\n.reportCard .news_image_box {\n  height: 245px;\n}\n.reportCard_description {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.news-card .row {\n  height: 100%;\n}\n.news-card .row > [class*=\"col-\"] {\n  height: 100%;\n}\n.card_detail_box {\n  padding: 14px;\n}\n.news_card_title {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 12px;\n}\n.card_description {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0;\n}\n.news_image_box {\n  height: 288px;\n}\n.news_detail {\n  .active_news {\n    width: 6px;\n    height: 6px;\n    background: var(--green);\n    border-radius: 50px;\n    display: inline-block;\n    margin-right: 10px;\n  }\n  .category {\n    background: rgba(51, 51, 51, 0.1);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    padding: 3px 10px;\n    font-size: 12px;\n    max-width: 140px;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n    line-height: 1.25;\n  }\n  .post_time {\n    color: var(--white);\n    display: inline-block;\n    flex-shrink: 0;\n    font-size: 12px;\n  }\n}\n\n.progress-container {\n  width: 100%;\n  max-width: 32px;\n  aspect-ratio: 1;\n}\n\n.circular-progress {\n  --size: 100%;\n  --thickness: 2px;\n  --angle: calc(var(--progress) * 3.6deg);\n  width: var(--size);\n  height: var(--size);\n  border-radius: 50%;\n  background: conic-gradient(#22c55e var(--angle), #2e2e3d 0deg 360deg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  padding: 6px;\n}\n\n.circular-progress::before {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - var(--thickness) * 2);\n  height: calc(100% - var(--thickness) * 2);\n  background-color: #1e1e2f;\n  border-radius: 50%;\n}\n\n.progress-value {\n  position: relative;\n  color: white;\n  font-size: 10px;\n}\n\n/* all news tabs */\n.news_comments {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  padding: 16px;\n}\n.news_comments--fixed {\n  height: auto;\n  display: block;\n  box-sizing: border-box;\n}\n.news_comments--fixed .news-tab-content {\n  overflow: visible;\n}\n.comment_title {\n  width: 80%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.comment_description {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.news_socialMedia_block,\n.news_sourace_block {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 6px 14px;\n  border-radius: 6px;\n      box-shadow: rgba(116, 121, 255, 0.2) 0px 0px 4px inset;\n}\n.news_sourace_block .source-avatars .source-icon {\n  margin-left: -12px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50px;\n  background-color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  object-fit: contain;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  &:first-child {\n    margin-left: 0;\n  }\n}\n.source-avatars .source_avtar_link{\n  margin-left: -6px;\n  display:inline-block;\n  &:first-child {\n    margin-left: 0;\n  }\n}\n.global-impact-popover {\n  position: absolute;\n  width: min(260px, calc(100% - 24px));\n  max-height: min(220px, calc(100% - 24px));\n  overflow: hidden;\n  padding: 12px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: radial-gradient(circle at 70% 20%, rgba(84, 84, 100, 0.3), rgba(22, 24, 34, 0.96));\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  z-index: 30;\n}\n.global-impact-popover.is-pinned {\n  border-color: rgba(132, 204, 255, 0.4);\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.45), 0 0 0 1px rgba(132, 204, 255, 0.25) inset;\n}\n.global-impact-popover-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n.global-impact-popover-title {\n  color: #fff;\n  font-size: 15px;\n  line-height: 1.2;\n  font-weight: 700;\n}\n.global-impact-popover-count {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.global-impact-popover-subtitle {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 15px;\n  font-weight: 700;\n  margin-bottom: 8px;\n}\n.global-impact-popover-sources {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 150px;\n  overflow-y: auto;\n}\n.global-impact-source-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 24px;\n  color: #fff;\n  text-decoration: none;\n}\n.global-impact-source-link:hover {\n  color: #fff;\n  text-decoration: underline;\n}\n.global-impact-source-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  background: #fff;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n.global-impact-source-name {\n  color: #fff;\n  font-size: 13px;\n  line-height: 1.2;\n  font-weight: 500;\n}\n.global-impact-source-empty {\n  color: rgba(255, 255, 255, 0.72);\n  font-size: 13px;\n}\n.source-more-wrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  z-index: 5;\n}\n.source-more-trigger {\n  cursor: pointer;\n}\n.source-more-popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 260px;\n  max-width: 340px;\n  max-height: 320px;\n  overflow-y: auto;\n  background: rgba(20, 20, 28, 0.96);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);\n  padding: 10px;\n  z-index: 2000;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(4px);\n  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;\n}\n.news-detail-panel {\n  position: relative;\n  z-index: 20;\n}\n.customize-article-panel {\n  position: relative;\n  z-index: 1;\n}\n.source-more-wrapper:hover .source-more-popover,\n.source-more-wrapper:focus-within .source-more-popover {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n.source-more-title {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n.source-more-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.source-more-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #fff;\n  font-size: 12px;\n  padding: 6px 8px;\n  border-radius: 8px;\n}\n.source-more-link {\n  text-decoration: none;\n}\n.source-more-link:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n.source-more-icon {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex: 0 0 auto;\n}\n.source-more-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.source-more-note {\n  color: rgba(255, 255, 255, 0.65);\n  font-style: italic;\n}\n.news_socialMedia_block .social-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50px;\n   margin-left: -12px;\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.news-tabs {\n  display: flex;\n  gap: 10px;\n  border-radius: 50px;\n  background: rgba(51, 51, 51, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 4px;\n  list-style: none;\n  width: 100%;\n}\n\n.news-tab-item {\n  flex: 1; /* each tab takes equal space */\n}\n\n.news-tab-btn {\n  background: transparent;\n  border: none;\n  color: #fff;\n  padding: 9px 4px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  border-radius: 40px;\n  color: #828282;\n}\n\n.news-tab-btn.active {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  color: #fff;\n  box-shadow: inset 0 0 8px rgba(116, 121, 255, 0.3);\n}\n\n.news_comment_card {\n  background: rgba(51, 51, 51, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-radius: 12px;\n  padding: 16px;\n  color: #fff;\n}\n\n/* matching news  */\n\n.view-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  background: #0b0b1a; /* dark background to match image */\n  border-radius: 50px;\n  padding: 6px;\n  gap: 6px;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: inset 0 0 8px rgba(116, 121, 255, 0.3);\n}\n\n.toggle_btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  font-size: 22px;\n  border-radius: 40px;\n  padding: 10px 16px;\n  cursor: pointer;\n  color: rgba(255, 255, 255, 0.5); /* inactive state */\n  transition: all 0.3s ease;\n  position: relative;\n  z-index: 1;\n}\n\n.toggle_btn.toggle-active {\n  background: rgba(255, 255, 255, 0.06);\n  color: #ffffff;\n  box-shadow: inset 0 0 8px rgba(116, 121, 255, 0.3);\n}\n\n.question_wrap {\n  background: rgba(255, 255, 255, 0.05); /* glass effect */\n  border-radius: 12px;\n  padding: 30px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #f1f1f1;\n  line-height: 1.6;\n  font-size: 15px;\n}\n\n.matching_heading_box .title {\n  font-family: \"NeoSans\";\n  text-transform: uppercase;\n}\n\n.question_wrap h5 {\n  color: #ffffff;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.question_wrap a {\n  color: var(--primary-74); /* bluish like your screenshot */\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.question_wrap a:hover {\n  color: var(--primary-74); /* purple on hover */\n  text-decoration: underline;\n}\n\n.question_wrap strong {\n  font-weight: 700;\n  color: #fff;\n}\n/* news viwe*/\n\n.news_views_banner_image .image_box {\n  aspect-ratio: 16/9;\n  width: 100%;\n}\n.action_box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.3);\n  color: var(--white);\n}\n.action_button_box {\n  display: flex;\n  align-items: center;\n}\n.action_box .title_box {\n  border-right: 1px solid rgba(116, 121, 255, 0.3);\n  display: inline-block;\n  padding: 10px 20px 10px 5px;\n}\n.action_box .action_btn {\n  border: 0;\n  background: transparent;\n  color: var(--white);\n  display: flex;\n  align-items: center;\n  padding: 10px 20px;\n  gap: 10px;\n  border-left: 1px solid rgba(116, 121, 255, 0.3);\n}\n\n.mini_detail_box {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  padding: 28px 28px 28px 40px;\n  border-radius: 12px;\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.3);\n  position: relative;\n  &::before {\n    position: absolute;\n    content: \"\";\n    height: 80%;\n    width: 2px;\n    background: var(--white);\n    top: 50%;\n    transform: translateY(-50%);\n    left: 20px;\n    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);\n  }\n}\n\n.news_detail_description_box {\n  a {\n    color: var(--purple);\n  }\n  img {\n    max-width: 100%;\n  }\n}\n\n/* custom tool tip */\n.tooltip_wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.custom_anchor {\n  color: var(--white);\n  background: var(--primary-74);\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n  margin-left: 5px;\n}\n\n.custom_tooltip_box {\n  position: absolute;\n  top: 26px;\n  left: 20%;\n  transform: translateX(-20%);\n  background: rgba(255, 255, 255, 0.01);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  border-radius: 12px;\n  padding: 12px;\n  max-width: 450px;\n  width: calc(100vw - 30px);\n  z-index: 10;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n  color: #ffffff;\n  pointer-events: none;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n\n  /* Prevent tooltip from overflowing left/right */\n  box-sizing: border-box;\n}\n\n.tooltip_wrapper:hover .custom_tooltip_box {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.tooltip_content {\n  display: flex;\n  align-items: flex-start;\n}\n\n.tooltip_img {\n  width: 90px;\n  height: 90px;\n  object-fit: cover;\n  border-radius: 10px;\n}\n\n.tooltip_title {\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.tooltip_description {\n  font-size: 0.85rem;\n  line-height: 1.4;\n}\n\n.tooltip_buttons .custom_btn_success {\n  background: #252630;\n  color: var(--white);\n  border-radius: 8px;\n  padding: 9px 10px;\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  border: 0;\n}\n\n.tooltip_buttons .custom_btn_primary {\n  background: #312b59;\n  color: var(--white);\n  border-radius: 8px;\n  padding: 9px 10px;\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  border: 0;\n}\n.tooltip_buttons button {\n  font-size: 0.75rem;\n}\n\n/* customize panel */\n.custom_panel_box .bg_glassEffect {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  padding: 16px;\n  border-radius: 25px;\n  color: var(--white);\n}\n\n.custom-section-title {\n  font-family: \"NeoSans\";\n  text-align: center;\n}\n.custom-customize-box .custom-label {\n  font-size: 14px;\n  font-weight: 300;\n  padding-bottom: 10px;\n}\n.custom-customize-box .custom_tab {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  padding: 8px;\n  border-radius: 40px;\n}\n.custom-toggle {\n  padding: 6px 10px;\n  cursor: pointer;\n  text-align: center;\n  font-size: 12px;\n  white-space: nowrap;\n}\n.activetab {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  padding: 6px 20px;\n  border-radius: 40px;\n  color: var(--purple);\n}\n.self_togle_wrap .custom-toggle {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  padding: 9px 10px;\n  border-radius: 40px;\n  font-size: 12px;\n  cursor: pointer;\n}\n.self_togle_wrap .custom-toggle .activeTab {\n  color: var(--purple);\n}\n\n/* share diaglog */\n\n.share-dialog {\n  position: absolute;\n  top: -11rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(20px);\n  color: white;\n  z-index: 999;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);\n}\n\n.share-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 0.8rem;\n  color: white;\n}\n.circle_icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  margin-bottom: 8px;\n  font-size: 20px;\n  cursor: pointer;\n  transition: box-shadow 0.3s ease, transform 0.2s ease;\n}\n\n.circle_icon:hover {\n  box-shadow: 0 0 12px rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n/* Twitter */\n.bgtwitter {\n  background-color: #1da0f286;\n  border: 1px solid #1da1f2;\n  color: #1da1f2;\n}\n\n/* Facebook */\n.bgfacebook {\n  background-color: #3b599888;\n  border: 1px solid #3b5998;\n  color: #3b5998;\n}\n\n/* WhatsApp */\n.bgtwhatsapp {\n  background-color: #25d3663d;\n  border: 1px solid #25d366;\n  color: #25d366;\n}\n\n/* Reddit */\n.bgreddit {\n  background-color: #ff450048;\n  border: 1px solid #ff4500;\n  color: #ff4500;\n}\n\n/* footer */\n\n.df-footer {\n  color: var(--white);\n  padding: 30px 0;\n  font-size: 14px;\n}\n\n.df-footer-logo {\n  font-weight: bold;\n  font-size: 18px;\n  margin-bottom: 20px;\n}\n\n/* The links sit next to each other in the JSX without whitespace; as inline\n   elements there is no break opportunity between them, and on narrow phones\n   the row ran past the edge (clipped, since body has overflow-x: hidden).\n   Wrapping flex keeps the desktop spacing (2 x 12px) and breaks into several\n   centered rows on mobile. */\n.df-footer-nav {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px 24px;\n  padding: 0 8px;\n}\n\n.df-footer-nav a {\n  color: var(--white);\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.df-footer-nav a:hover {\n  text-decoration: underline;\n}\n\n.df-footer-divider {\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  margin: 25px 0;\n  width: 100%;\n}\n.df-footer-legal {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px 15px;\n}\n.df-footer-legal a {\n  color: var(--white);\n  font-size: 13px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.df-footer-legal a:hover {\n  text-decoration: underline;\n}\n\n/* common style */\n.fs_30 {\n  font-size: 30px;\n}\n.pt_100 {\n  padding-top: 100px;\n}\n/* media query */\n@media (max-width: 1440px) {\n  .flex-wrap {\n    flex-direction: column-reverse;\n  }\n  .category_wrap {\n    justify-content: space-between;\n    width: 100%;\n  }\n}\n@media (max-width: 1366px) {\n  .hot_news_detail {\n    flex-wrap: wrap;\n  }\n  /* .sidebar_wrap {\n    width: 220px;\n    padding: 16px;\n  }\n  .main_layout_content {\n    margin-left: 220px;\n  } */\n}\n@media (max-width: 1025px) {\n  .header_left_side {\n    width: 76%;\n  }\n  .news_comments {\n    background: none;\n    backdrop-filter: unset;\n    -webkit-backdrop-filter: unset;\n    border-radius: 0;\n    box-shadow: none !important;\n    padding: 0;\n  }\n  .news-tabs {\n    background: rgba(51, 51, 51, 0.3);\n    max-width: 550px;\n    margin: 0 auto;\n  }\n  .pin_icon {\n    display: none !important;\n  }\n  .generate_report_box {\n    flex-wrap: wrap;\n    flex-direction: column;\n  }\n  .search-txt.with-files {\n    padding: 37px !important;\n  }\n}\n\n@media (max-width: 600px) {\n  .sidebar_wrap {\n    width: 0px;\n    padding: 4px;\n    z-index: 22;\n    transform: translateX(-10px);\n    transition: all 0.3s ease-in-out;\n  }\n  .action_box .action_btn {\n    padding: 10px !important;\n  }\n  .heading_box .news_view_title {\n    font-size: 20px;\n  }\n\n  .action_button_box {\n    justify-content: space-between;\n    flex-grow: 1;\n  }\n  .sidebar_wrap.collapsed {\n    width: 250px;\n    overflow: hidden;\n    transform: translateX(0px);\n  }\n  .sidebar_wrap.collapsed .user_section .user_detail,\n  .sidebar_wrap.collapsed .sidebar__menu__list li span,\n  .sidebar_wrap.collapsed .brand_text,\n  .sidebar_wrap.collapsed .user_info {\n    display: block;\n    opacity: 1;\n  }\n  .sidebar_wrap.user_section .user_detail,\n  .sidebar_wrap.sidebar__menu__list li span,\n  .sidebar_wrap.brand_text,\n  .sidebar_wrap.user_info {\n    display: block;\n    opacity: 0;\n    transition: all 0.3s ease-in-out;\n    transition-delay: 0.2s;\n  }\n  .sidebar_wrap .brand_section,\n  .sidebar_wrap .user_section,\n  .sidebar__menu__list li a {\n    justify-content: unset;\n  }\n  .main_layout_content {\n    margin-left: 0px !important;\n    width: 100%;\n  }\n\n  .news-tab-btn {\n    font-size: 12px;\n  }\n  .news_comment_card {\n    padding: 10px;\n  }\n  .df-footer-legal {\n    justify-content: center;\n  }\n  .df-footer-nav {\n    gap: 8px 18px;\n  }\n  .card_description {\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    margin-bottom: 0;\n  }\n  .news_card_title {\n    font-size: 18px;\n  }\n  .card_detail_box {\n    padding: 14px 14px 0px 14px;\n  }\n  .action_box .title_box {\n    display: none !important;\n    border-right: unset !important;\n    display: inline-block;\n    padding: 0 !important;\n  }\n  .action_button_box .action_btn:first-child {\n    border: none;\n  }\n\n  .main_layout_content {\n    padding: 8px;\n  }\n}\n\n.no-margin-top {\n  margin-top: 0 !important;\n}\n\n/* Ensure UI controls inherit the global font */\ninput,\nbutton,\nselect,\ntextarea {\n  font: inherit;\n}\n\n.mini_transparent_btn {\n  background: rgba(255, 255, 255, 0.09);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  border-radius: 5px;\n  border: 0;\n  outline: 0;\n  color: #fff;\n  padding: 6px 20px 4px;\n}\n.text_purple {\n  color: var(--purple);\n}\n\n/* reports*/\n.reportPoster_img_wrap {\n  height: 200px;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 12px;\n  position: relative;\n  transition: all 0.3s ease;\n  .title {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    backdrop-filter: blur(10px); /* glass blur effect */\n    -webkit-backdrop-filter: blur(10px);\n    padding: 12px;\n    text-align: center;\n  }\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.4);\n  }\n  .report_overview_posterImg {\n    bottom: unset !important;\n    background: rgba(0, 0, 0, 0.55);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n  }\n}\n\n/* === Tabs === */\n\n.reports_souraces_tabs .custom_tabs {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 50px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  width: fit-content;\n  max-width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.reports_souraces_tabs .custom_tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.reports_souraces_tabs .custom_tabs .nav-item {\n  flex: 0 0 auto;\n}\n\n/* Tabs (buttons) */\n.reports_souraces_tabs .custom_tabs .nav-link {\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 50px;\n  padding: 8px 18px;\n  transition: all 0.3s ease;\n  background: transparent;\n  border: none;\n  line-height: 1.2;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n/* Active tab */\n.reports_souraces_tabs .custom_tabs .nav-link.active {\n  background: #25233d;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  color: #fff;\n}\n\n/* reports view page */\n\n.small_cricle_icon {\n  width: 26px;\n  height: 26px;\n  border-radius: 50px;\n  background: #f0f0f0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.reportViewBannerImgWrap .image_box {\n  height: 250px;\n  width: 100%;\n  position: relative;\n  .post_title {\n    background: rgba(0, 0, 0, 0.52);\n    backdrop-filter: blur(12px);\n    -webkit-backdrop-filter: blur(12px);\n    padding: 10px 25px;\n    border-radius: 40px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);\n    z-index: 2;\n  }\n}\n\n.report-hero-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0.62) 0%,\n    rgba(0, 0, 0, 0.35) 40%,\n    rgba(0, 0, 0, 0.72) 100%\n  );\n  pointer-events: none;\n  z-index: 1;\n}\n\n.bg_glassEffect {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(20px);\n  box-shadow: inset 0 0 4px rgba(116, 121, 255, 0.2);\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Box container */\n.content_enhance_wrap {\n  padding: 20px;\n  color: #fff;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n/* Title */\n.enhance_title {\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 12px;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n/* Textarea */\n.enhance_textarea {\n  width: 100%;\n  height: 100px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  resize: none;\n  outline: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.enhance_textarea::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Buttons */\n.enhance_btns {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.btn_enhance,\n.btn_rewrite {\n  width: 120px;\n  height: 34px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn_enhance:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.btn_rewrite.active {\n  background: linear-gradient(#9999994d, #9999994d),\n    linear-gradient(#333333c9, #333333c9), linear-gradient(#5e3afc33, #5e3afc33),\n    #000000;\n  background-blend-mode: darken, luminosity, normal;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n/* Trending topics */\n.tranding_topic_list {\n  max-height: 180px;\n  overflow-y: auto;\n  margin-top: 30px;\n  padding: 0px 25px;\n\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    background-color: #241f3b;\n  }\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    background-color: #241f3b;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: #938585;\n    border-radius: 40px;\n  }\n}\n\n.tranding_topic_list ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.tranding_topic_list li {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 14px;\n  padding: 11px 0;\n  text-align: end;\n}\n.tranding_topic_list li:last-child {\n  border-bottom: none;\n}\n\n.reports_overview_tabsBox {\n  .report_overview_accordion {\n    --bs-accordion-color: #fff;\n    --bs-accordion-bg: transparent;\n    --bs-accordion-border-color: transparent;\n    --bs-accordion-border-radius: 8px;\n    --bs-accordion-btn-focus-box-shadow: none;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    .accordion-item {\n      background-color: transparent;\n      border: none;\n      box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n        2px 0 2px rgba(255, 255, 255, 0.3);\n      border-radius: 8px;\n      overflow: hidden;\n\n      .accordion-header {\n        .accordion-button {\n          background-color: #2a283e;\n          color: #fff;\n          font-weight: 600;\n          font-size: 14px;\n          letter-spacing: 0.5px;\n          border: none;\n          box-shadow: none;\n          padding: 12px 20px;\n          border-radius: 0;\n          transition: all 0.3s ease;\n\n          &:focus {\n            box-shadow: none;\n          }\n\n          &::after {\n            background-image: url(\"./assets/images/close_collapse.svg\");\n            transform: rotate(0deg);\n          }\n\n          &.collapsed::after {\n            background-image: url(\"./assets/images/open_collapse.svg\");\n          }\n        }\n      }\n\n      .accordion-body {\n        padding: 24px;\n        border-top: 1px solid rgba(255, 255, 255, 0.1);\n      }\n    }\n  }\n}\n\n/* ai generate report  */\n\n/* Base textarea */\n.search-txt.with-files {\n  padding: 60px;\n  transition: all 0.3s ease;\n}\n\n/* File preview inside input */\n.inner-files-wrapper {\n  position: absolute;\n  top: 8px;\n  left: 10%;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.inner-file-preview {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(6px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 20px;\n  position: relative;\n  box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.15);\n  z-index: 22;\n\n  .remove-file-btn {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    background: rgba(255, 255, 255, 0.3);\n    border: none;\n    color: #fff;\n    border-radius: 50%;\n    width: 16px;\n    height: 16px;\n    font-size: 10px;\n    padding: 2px;\n    line-height: 1;\n    cursor: pointer;\n  }\n}\n\n/* Upload modal */\n.upload-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 10, 25, 0.5);\n  backdrop-filter: blur(3px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050;\n}\n\n.upload-modal {\n  background: rgba(60, 60, 90, 0.3);\n  backdrop-filter: blur(25px);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  padding: 30px 50px;\n  width: 420px;\n  height: 230px;\n  text-align: center;\n  color: #fff;\n  box-shadow: 0 0 30px rgba(255, 255, 255, 0.08);\n  transition: all 0.3s ease;\n\n  .upload-content {\n    position: relative;\n    height: 100%;\n    align-content: center;\n    p {\n      color: #ffffffb3;\n      font-size: 15px;\n    }\n\n    .upload-icon {\n      margin-right: 8px;\n    }\n\n    .file-input {\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      cursor: pointer;\n    }\n  }\n}\n\n.affected_price_table {\n  --bs-table-bg: transparent;\n  --bs-table-color: #f0f0f0 !important;\n}\n\n/* Stability Bar */\n.stability-bar {\n  display: flex;\n  align-items: center;\n}\n\n.stability-bar .bar {\n  width: 18px;\n  height: 5px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n  transition: background 0.3s;\n}\n\n.stability-bar .bar.active {\n  background-color: #986e3b;\n}\n\n.stability-bar .bar:not(:last-child) {\n  margin-right: 3px;\n}\n\n.reportCard_wrapper {\n  position: relative;\n}\n\n.reportCard_overlay {\n  position: absolute;\n  inset: 0;\n  backdrop-filter: blur(6px);\n  background: rgba(0, 0, 0, 0.35);\n  border-radius: 12px;\n  z-index: 2;\n}\n\n.report-eta-modal {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.42);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2050;\n}\n\n.report-eta-modal-content {\n  min-width: 280px;\n  max-width: 420px;\n  border-radius: 12px;\n  padding: 16px;\n  color: #fff;\n  background: rgba(21, 24, 38, 0.9);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
